import { useState, useEffect, useCallback } from 'react'
import { Business } from '@/lib/db/schema'
import { CreateBusinessInput } from '@/lib/validation/business'

export function useBusinesses() {
  const [businesses, setBusinesses] = useState<Business[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchBusinesses = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const res = await fetch('/api/businesses')
      const json = await res.json() as any
      if (res.ok && json.success) {
        setBusinesses(json.data)
      } else {
        setError(json.error?.message || 'Failed to fetch businesses')
      }
    } catch (err: any) {
      setError(err.message || 'Network error')
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchBusinesses()
  }, [fetchBusinesses])

  const createBusiness = async (payload: CreateBusinessInput) => {
    const res = await fetch('/api/businesses', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    const json = await res.json() as any
    if (res.ok && json.success) {
      return { success: true, data: json.data as Business }
    }
    return { success: false, error: json.error?.message || 'Failed to create business', fields: json.error?.fields }
  }

  return { businesses, isLoading, error, refetch: fetchBusinesses, createBusiness }
}
